/** 依網址決定本次需要的資料；詳細頁與所屬 Tab 共用同一組資料。 */
export function getMiniAppSection(path: string, isTeacher = true) {
  const normalized = `/${path}`.replace(/\/{2,}/g, '/').replace(/\/$/, '');
  if (isTeacher && (normalized === '/teacher' || normalized.startsWith('/teacher/'))) {
    if (normalized.startsWith('/teacher/compensation')) return 'teacher-compensation';
    if (normalized.startsWith('/teacher/calendar')) return 'teacher-calendar';
    if (normalized.startsWith('/teacher/sales')) return 'teacher-sales';
    if (normalized.startsWith('/teacher/records')) return 'teacher-history';
    return 'teacher-today';
  }
  if (normalized.startsWith('/teachers')) return 'teachers';
  if (normalized.startsWith('/courses')) return 'courses';
  if (normalized.startsWith('/booking')) return 'booking';
  if (normalized.startsWith('/records')) return 'records';
  return 'home';
}

export function getMiniAppDataNeeds(path: string, isTeacher: boolean) {
  const section = getMiniAppSection(path, isTeacher);
  return {
    section,
    plans: ['courses', 'booking', 'teacher-sales'].includes(section),
    credits: ['home', 'courses', 'booking'].includes(section),
    bookings: ['home', 'records', 'booking'].includes(section),
    slots: section === 'booking' && !/^\/booking\/(?:complete|failed)\//.test(path),
    teachers: ['home', 'teachers', 'booking'].includes(section),
    teacherBookings: section === 'teacher-today' || section === 'teacher-calendar',
    teacherHistory: section === 'teacher-history',
    teacherCalendar: section === 'teacher-calendar',
    teacherSales: section === 'teacher-sales',
  };
}
